module.exports = __webpack_public_path__ + "static/media/how-step2.45894210.svg";